var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2075 4.89993L11.4144 2.10743C11.3215 2.01454 11.2113 1.94086 11.0899 1.8906C10.9686 1.84033 10.8385 1.81445 10.7072 1.81445C10.5759 1.81445 10.4458 1.84033 10.3245 1.8906C10.2031 1.94086 10.0929 2.01454 10 2.10743L2.29313 9.8143C2.19987 9.90682 2.12593 10.017 2.0756 10.1383C2.02528 10.2597 1.99959 10.3898 2.00001 10.5212V13.3143C2.00001 13.5795 2.10536 13.8339 2.2929 14.0214C2.48043 14.2089 2.73479 14.3143 3.00001 14.3143H5.79313C5.9245 14.3147 6.05464 14.289 6.17599 14.2387C6.29735 14.1884 6.40748 14.1144 6.50001 14.0212L11.7294 8.79243L11.9469 9.66118L9.64688 11.9606C9.55306 12.0543 9.50032 12.1815 9.50026 12.3141C9.5002 12.4467 9.55283 12.5739 9.64657 12.6677C9.74031 12.7616 9.86747 12.8143 10.0001 12.8144C10.1327 12.8144 10.2599 12.7618 10.3538 12.6681L12.8538 10.1681C12.9149 10.107 12.9592 10.0312 12.9823 9.94793C13.0054 9.86469 13.0066 9.77687 12.9856 9.69305L12.5544 7.96743L14.2075 6.3143C14.3004 6.22144 14.3741 6.11119 14.4243 5.98985C14.4746 5.86851 14.5005 5.73846 14.5005 5.60711C14.5005 5.47577 14.4746 5.34572 14.4243 5.22438C14.3741 5.10304 14.3004 4.99279 14.2075 4.89993ZM3.00001 11.5212L4.79313 13.3143H3.00001V11.5212ZM6.00001 13.1074L3.20688 10.3143L8.50001 5.02118L11.2931 7.8143L6.00001 13.1074ZM12 7.10743L9.20751 4.3143L10.7075 2.8143L13.5 5.60743L12 7.10743Z",
    fill: "#344054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.eb5ae3f73aa4251f124fbdb50a17a0b6.svg";
export { ForwardRef as ReactComponent };